import { createFileRoute } from "@tanstack/react-router";
import GrantsDirectory from "@/pages/GrantsDirectory";
import { sectorFromSlug, sectorHead } from "@/lib/subvencionesSeo";

export const Route = createFileRoute("/subvenciones/sector/$sector")({
  head: ({ params }) => {
    const name = sectorFromSlug(params.sector) ?? params.sector;
    const h = sectorHead("es", name);
    return {
      meta: [
        { title: h.title },
        { name: "description", content: h.description },
        { name: "keywords", content: h.keywords },
        { property: "og:title", content: h.title },
        { property: "og:description", content: h.description },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
    };
  },
  component: () => <GrantsDirectory kind="sector" />,
});
